import { BrowserRouter } from 'react-router-dom';
import { ConfirmProvider } from 'material-ui-confirm';

import Clerk from './Clerk';
import { AppContainer } from './style';

function App() {
  return (
    <BrowserRouter basename="/app">
      <AppContainer>
        <ConfirmProvider>
          <Clerk></Clerk>
        </ConfirmProvider>
      </AppContainer>
    </BrowserRouter>
  );
}

export default App;
